<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import SettingsHeader from './SettingsHeader.vue';
const props = defineProps({
  headerTitle: { type: String, default: '' },
  icon: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
  showBackButton: { type: Boolean, default: false },
  backUrl: { type: [String, Object], default: '' },
});

const { t } = useI18n();
const route = useRoute();
// Saving a GoWA draft adds its inbox ID to the URL without replacing the QR wizard.
const viewKey = computed(() =>
  route.name === 'settings_inboxes_page_channel' &&
  route.query.provider === 'gowa'
    ? `${route.path}?provider=gowa`
    : route.fullPath
);

const showSettingsHeader = computed(
  () => props.headerTitle || props.icon || props.showBackButton
);
</script>

<template>
  <div class="flex flex-col h-full m-0 bg-n-surface-1 w-full">
    <SettingsHeader
      v-if="showSettingsHeader"
      :icon="icon"
      :header-title="t(headerTitle)"
      :show-back-button="showBackButton"
      :back-url="backUrl"
      class="z-20 max-w-7xl w-full mx-auto"
    />

    <router-view v-slot="{ Component }" class="px-4 overflow-hidden">
      <component :is="Component" v-if="!keepAlive" :key="viewKey" />
      <keep-alive v-else>
        <component :is="Component" :key="viewKey" />
      </keep-alive>
    </router-view>
  </div>
</template>
